import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  title: string;
  description: string;
  color: string;
  badge?: string;
};

/**
 * 色付きアクセントカード
 */
const WorkflowColorCard: React.FC<Props> = ({ title, description, color, badge }) => {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        borderTop: 3,
        borderTopColor: color,
        p: 2,
        height: '100%',
      }}
    >
      <Stack spacing={0.5}>
        {badge && (
          <Box
            sx={{
              display: 'inline-block',
              px: 1,
              py: 0.25,
              borderRadius: 1,
              bgcolor: `${color}20`,
              color: color,
              fontSize: '0.65rem',
              fontWeight: 700,
              width: 'fit-content',
            }}
          >
            {badge}
          </Box>
        )}
        <Typography variant="body2" fontWeight={600}>
          {title}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {description}
        </Typography>
      </Stack>
    </Box>
  );
};

export default WorkflowColorCard;
